module.exports = __webpack_public_path__ + "static/media/heroimage_igib-001.844ca6eb.jpg";